import { module } from "../app";

module.directive("noNewLine", function () {
  return {
    link: function (scope, element, attrs) {
      element.bind("keydown keypress", function (event) {
        if(event.which === 13) {
          scope.$apply(function (){
              scope.$eval(attrs.myEnter);
          });

          event.preventDefault();
        }
      });
    }
  };
});



// WEBPACK FOOTER //
// ./src/scripts/directives/no-new-line.js